import {isMobile} from "../functions";

document.addEventListener("DOMContentLoaded", function (dom) {
    const regionsBlock = dom.target.querySelector(".regions__block");

    if (regionsBlock) {
        const regionFeeds = regionsBlock.querySelectorAll(".feed-region");
        if (regionFeeds.length) {
            let prevRegionClick = false;
            const defaultActive = regionsBlock.querySelector(".default-active");
            regionFeeds.forEach(regionFeed => {
                const infoLink = regionFeed.querySelector(".info__link");
                if (infoLink) {
                    infoLink.addEventListener("click", function (e) {
                        e.preventDefault();
                        e.stopPropagation();
                        window.open(e.target.innerText);
                    });
                }
                regionFeed.addEventListener("mouseenter", function (e) {
                    regionFeed.classList.add("active");
                    if (defaultActive !== regionFeed) {
                        defaultActive.classList.remove("active");
                    }
                });

                regionFeed.addEventListener("mouseleave", function (e) {
                    regionFeed.classList.remove("active");
                    const activeItems = regionsBlock.querySelectorAll(".active");
                    if (activeItems.length === 0) {
                        regionsBlock.querySelector('.default-active').classList.add("active");
                    }
                });

                if (isMobile()) {
                    regionFeed.addEventListener('click', function (e) {
                        if (prevRegionClick !== regionFeed.id) {
                            e.preventDefault();
                            e.stopPropagation();
                            prevRegionClick = regionFeed.id;
                            regionFeed.classList.add("active");
                            if (defaultActive !== regionFeed) {
                                defaultActive.classList.remove("active");
                            }
                        } else {
                            regionFeed.classList.remove("active");
                            const activeItems = regionsBlock.querySelectorAll(".active");
                            if (activeItems.length === 0) {
                                regionsBlock.querySelector('.default-active').classList.add("active");
                            }
                        }
                    })
                }
            });
        }
    }
});

